module.exports = __webpack_public_path__ + "img/farming_24.9d9216a0.png";